import qs from 'qs';
import axios from 'axios';
import get from 'lodash/get';
import config from '../config';
import { refreshToken } from './auth';

const { apiUrl, clientId, clientSecret } = config;

const getHeaders = (token, contentType) => {
  return {
    Authorization: token ? `Bearer ${token}` : `Basic ${btoa(`${clientId}:${clientSecret}`)}`,
    Accept: 'application/json',
    'Content-Type': contentType || 'application/json',
  };
};

const apiCall = (apiFucntion, requestConfig, auth, setAuth) => {
  return apiFucntion(requestConfig)
    .catch((err) => {
      if (
        get(auth, 'access_token')
        && get(err, 'response.status') === 401
        && get(err, 'response.data.error') === 'The request requires user authentication'
      ) {
        return refreshToken(get(auth, 'refresh_token'))
          .then(({ data: newAuth }) => {
            newAuth.user = auth.user;
            setAuth(newAuth);
            const newRequestConfig = { ...requestConfig, headers: getHeaders(get(newAuth, 'access_token')) };
            return apiFucntion(newRequestConfig)
          })
          .catch(refreshErr => {
            if (get(refreshErr, 'response.status') === 401) {
              throw err;
            }
            throw refreshErr;
          });
      } 
      throw err;
    });
};

const api = {
  get: (url, params, auth, setAuth) => {
    const fullUrl = `${apiUrl}${url}`;
    const requestConfig = {
      headers: getHeaders(get(auth, 'access_token')),
      paramsSerializer: qs.stringify,
      params,
    };
    const apiGet = (config) => axios.get(fullUrl, config);
    return apiCall(apiGet, requestConfig, auth, setAuth);
  },
  post: (url, body, auth, setAuth) => {
    const fullUrl = `${apiUrl}${url}`;
    const data = JSON.stringify(body);
    const requestConfig = {
      headers: getHeaders(get(auth, 'access_token')),
    };
    const apiPost = (config) => axios.post(fullUrl, data, config);
    return apiCall(apiPost, requestConfig, auth, setAuth);
  },
  put: (url, body, auth, setAuth) => {
    const fullUrl = `${apiUrl}${url}`;
    const data = JSON.stringify(body);
    const requestConfig = {
      headers: getHeaders(get(auth, 'access_token'))
    };
    const apiPut = (config) => axios.put(fullUrl, data, config);
    return apiCall(apiPut, requestConfig, auth, setAuth);
  },
  delete: (url, auth, setAuth) => {
    const fullUrl = `${apiUrl}${url}`;
    const requestConfig = {
      headers: getHeaders(get(auth, 'access_token')),
    };
    const apiDelete = (config) => axios.delete(fullUrl, config);
    return apiCall(apiDelete, requestConfig, auth, setAuth);
  },
  postUrlFormEncoded: (url, body, auth, setAuth) => {
    const fullUrl = `${apiUrl}${url}`;
    const data = qs.stringify(body);
    const requestConfig = {
      headers: getHeaders(get(auth, 'access_token'), 'application/x-www-form-urlencoded'),
    };
    const apiPostUrlEncoded = (config) => axios.post(fullUrl, data, config);
    return apiCall(apiPostUrlEncoded, requestConfig, auth, setAuth);
  },
};

export default api;
